import Page from "~/pages/Page";
import { getApi, handleError, logout } from "~/auth";
import * as validation from "~/utils/validation";
import UI from "~/ui";
import { format, parse } from "date-fns";
import $ from "jquery";
import { gotoLogin } from "~/utils";
import { DatiAnagrafici } from "~/components/DatiAnagrafici";
import DocumentoModal from "~/components/modals/DocumentoModal";
import { SoggettoVenditaAcquistoModal } from "~/components/modals/SoggettoVenditaAcquistoModal";
import { initializeInputMasks } from "~/input-mask";
import { t } from "~/hooks/useI18n";
import { initTablePlus } from '~/tablePlus';

import {
    DeleteDocumentoGara,
    DeleteDocumentoGaraByOffertaIdAndTipo,
    uploadDocumentoGara
} from "~/services/documentService";

// ✅ Importa utility validazione file
import {
    ALLOWED_FILE_EXTENSIONS,
    validateAndShowFileError,
    formatFileSize,
    showFileError,
    clearFileError,
    showCustomFileError,
    clearCustomFileError,
    validateMaskedFileInputWithBorder
} from "~/utils/fileValidation";


class AdPropostaAcquisto extends Page {
    private _btnSalvaProfilo: HTMLFormElement = document.getElementById("btnSalvaProfilo") as HTMLFormElement;
    private theFormStep3: HTMLFormElement = document.getElementById("formStep3") as HTMLFormElement;
    private theFormStep4: HTMLFormElement = document.getElementById("formStep4") as HTMLFormElement;
    private formDataStep3: Record<string, string> = {};
    private _tabProfilo: DatiAnagrafici = new DatiAnagrafici();
    private _documentoModal: DocumentoModal = new DocumentoModal("#modalCaricaDocumentoUtente", "frmDocumentoUtente");
    private _SoggettoVenditaAcquistoModal: SoggettoVenditaAcquistoModal = new SoggettoVenditaAcquistoModal("#modalSoggettoVenditaAcquisto", "frmSoggettoVenditaAcquisto");
    private _offertaId: number = 0; // Aggiungi l'ID dell'offerta
    private _venditaId: number = 0; // Aggiungi l'ID dell'offerta
    private _modalitaAcquistoId: number = 0; // Aggiungi la modalità di acquisto
    private _allegatiVerificati: boolean = false;

    private UserId: number = 0; // Aggiungi l'ID dell'utente
    private userInfo: any = null; // Variabile globale per memorizzare le informazioni dell'utente
    private auth: any = null;

    // ✅ Snapshot dei dati per rilevare modifiche
    private _snapshotDatiOfferta: string | null = null;
    private _existePIA: boolean = false;

    constructor() {
        super("adpropostaacquisto", "AD Proposta Acquisto");
    }

    async pageStart(): Promise<void> {
        const that = this;
        initializeInputMasks();
        // Inizializza la validazione dei campi
        this._offertaId = parseInt($("#hdOffertaId").val() as string, 10);
        this._venditaId = parseInt($("#hdVenditaId").val() as string, 10);
        this._modalitaAcquistoId = parseInt($("#modalitaAcquisto").val() as string, 10);
        const value = ($("#hdAllegatiVerificati").val() as string)?.toLowerCase();
        this._allegatiVerificati = value === "true" || value === "1";

        this.auth = getApi();
        this.userInfo = this.auth.getCached("userInfo"); // Inizializza la variabile globale
        if (!this.userInfo) {
            gotoLogin();
            return Promise.reject("User not authenticated");
        }

        this.UserId = this.userInfo.anagraficaId; // Inizializza l'ID dell'utente

        const savedStep = sessionStorage.getItem("currentStep");
        if (savedStep) {
            await goToStep(Number(savedStep));
            sessionStorage.removeItem("currentStep");
        } else {
            // Attiva il tab Dati Personali
            let tab = this._tabProfilo;
            await tab.activate();
            console.log("Tab Dati Personali attivato");
            // Attivo il modal per il caricamento del documento utente
            await this._documentoModal.activate();

            // Nascondo il pulsante "Salva Profilo" nella pagina AdPropostaAcquisto
            const context = $("[data-context='AdPropostaAcquisto']");
            if (context.length > 0) {
                const btnSalvaProfilo = $("#btnSalvaProfilo");
                if (btnSalvaProfilo.length > 0) {
                    btnSalvaProfilo.addClass("d-none");
                }
            }
        }

        // Seleziona tutti i tab
        document.querySelectorAll('[data-bs-toggle="tab"]').forEach(function (tab) {
            tab.addEventListener('show.bs.tab', async function (event) {
                event.preventDefault();
                const currentTab = (event as any).relatedTarget as HTMLElement;
                const selectedTab = event.target as HTMLElement; // Tab che sta per essere selezionato

                if (!currentTab || !selectedTab) return;

                // Step del tab attualmente selezionato
                const selectedMatch = selectedTab.id.match(/step(\d+)-tab/);
                const selectedStepNumber = selectedMatch ? parseInt(selectedMatch[1], 10) : 0;

                // Step del tab precedente (già presente)
                const match = currentTab.id.match(/step(\d+)-tab/);
                const stepNumber = match ? parseInt(match[1], 10) : 0;

                const result = await isStepValid(selectedTab);
                if (result.isValid) {
                    await goToStep(selectedStepNumber);
                    // Ora puoi usare selectedStepNumber per sapere quale step è stato selezionato
                    console.log("Step selezionato:", selectedStepNumber);
                } else {

                    await goToStep(result.invalidStep ?? 1);
                    console.log("Step non valido:", result.invalidStep);
                }
            });
        });

        //controlla se sono presenti soggetti e visualizza o nasconde il pulsante aggiungi
        await this.loadStep2();

        // ✅ Snapshot verrà creato al primo accesso dello step 4 (quando i dati sono caricati)
        await this.controllaModifichePerStep4();

        async function isStepValid(tabElement: HTMLElement): Promise<{ isValid: boolean, invalidStep: number | null }> {
            console.log("Validazione step:", tabElement.id);
            switch (tabElement.id) {
                case "step01-tab":
                    if (!await that.ValidaStep01()) return { isValid: false, invalidStep: 1 };
                    break;
                case "step02-tab":
                    if (!await that.ValidaStep01()) return { isValid: false, invalidStep: 1 };
                    break;
                case "step03-tab":
                    if (!await that.ValidaStep01()) return { isValid: false, invalidStep: 1 };
                    if (!await that.ValidaStep02()) return { isValid: false, invalidStep: 2 };
                    break;
                case "step04-tab":
                    if (!await that.ValidaStep01()) return { isValid: false, invalidStep: 1 };
                    if (!await that.ValidaStep02()) return { isValid: false, invalidStep: 2 };
                    if (!await that.ValidaStep03()) return { isValid: false, invalidStep: 3 };

                    // ✅ Controlla se ci sono state modifiche quando si passa allo step 4
                    await that.controllaModifichePerStep4();
                    break;
                case "step05-tab":
                    if (!await that.ValidaStep01()) return { isValid: false, invalidStep: 1 };
                    if (!await that.ValidaStep02()) return { isValid: false, invalidStep: 2 };
                    if (!await that.ValidaStep03()) return { isValid: false, invalidStep: 3 };
                    if (!await that.ValidaStep04()) return { isValid: false, invalidStep: 4 };
                    break;
            }
            return { isValid: true, invalidStep: null };
        }

        $("#btnAvantiStep2").on("click", async (e) => {
            e.preventDefault(); // Previene il comportamento predefinito del pulsante
            try {
                const isUpdated = await this.ValidaStep01();
                if (isUpdated) {
                    console.log("Profilo aggiornato correttamente");
                    // Passa allo step successivo
                    goToNextStep(1);
                } else {
                    console.log("Errore durante l'aggiornamento del profilo");
                }
            } catch (error) {
                console.error("Errore durante l'aggiornamento del profilo:", error);
            }
        });

        $("#btnAvantiStep3").on("click", async (e) => {
            e.preventDefault(); // Previene il comportamento predefinito del pulsante
            try {
                const isUpdated = await this.ValidaStep02();
                if (isUpdated) {
                    console.log("Step 'Modalità di acquisto' salvato con successo");
                    // Passa allo step successivo
                    goToNextStep(2);
                }
            } catch (error) {
                console.error("Errore durante il salvataggio Step 'Modalità di acquisto':", error);
            }
        });

        $("#btnAvantiStep4").on("click", async (e) => {
            e.preventDefault(); // Previene il comportamento predefinito del pulsante

            const result = await that.ValidaStep03();
            if (!result) return;
            await that.controllaModifichePerStep4();
            goToNextStep(3);

        });

        $("#btnAvantiStep5").on("click", async function (e) {
            e.preventDefault(); // Previene il comportamento predefinito del pulsante

            const result = await that.ValidaStep04();

            if (!result) return;

            sessionStorage.setItem("currentStep", "5");
            window.location.reload();

        })

        $("#btnIndietroStep1").on("click", async (e) => {
            e.preventDefault(); // Previene il comportamento predefinito del pulsante
            goToPrevStep(2);
        })

        $("#btnIndietroStep2").on("click", async (e) => {
            e.preventDefault(); // Previene il comportamento predefinito del pulsante
            goToPrevStep(3);
        })

        $("#btnIndietroStep3").on("click", async (e) => {
            e.preventDefault(); // Previene il comportamento predefinito del pulsante
            goToPrevStep(4);
        })

        $("#btnIndietroStep4").on("click", async (e) => {
            e.preventDefault(); // Previene il comportamento predefinito del pulsante
            goToPrevStep(5);
        })


        async function goToStep(stepNumber: number) {   
            // Rimuove 'active' da tutti i tab
            $("[id^='step'][id$='-tab']").removeClass("active");
            // Rimuove 'show active' da tutti i tab-pane
            $("[id^='step'][id$='-tab-pane']").removeClass("show active");

            // Aggiunge 'active' al tab selezionato
            $(`#step${stepNumber.toString().padStart(2, '0')}-tab`).addClass("active");
            // Aggiunge 'show active' al tab-pane selezionato
            $(`#step${stepNumber.toString().padStart(2, '0')}-tab-pane`).addClass("show active");
            window.scrollTo({ top: 0, behavior: "smooth" });

            if (stepNumber === 5) {
                await that.refreshStep5(); // ✅ aggiunto await
            }
        }

        function goToNextStep(currentStepNumber: number) {
            const currentStepTab = $(`#step${currentStepNumber.toString().padStart(2, '0')}-tab`);
            const currentStepTabPane = $(`#step${currentStepNumber.toString().padStart(2, '0')}-tab-pane`);
            const nextStepNumber = currentStepNumber + 1;
            const nextStepTab = $(`#step${nextStepNumber.toString().padStart(2, '0')}-tab`);
            const nextStepTabPane = $(`#step${nextStepNumber.toString().padStart(2, '0')}-tab-pane`);

            if (currentStepTab.length > 0 && nextStepTab.length > 0) {
                currentStepTab.removeClass("active");
                currentStepTabPane.removeClass("show active");
                nextStepTab.addClass("active");
                nextStepTabPane.addClass("show active");
            }
            window.scrollTo({ top: 0, behavior: "smooth" });
            if (nextStepNumber === 5) {
                that.refreshStep5();
            }
        }

        function goToPrevStep(currentStepNumber: number) {
            const currentStepTab = $(`#step${currentStepNumber.toString().padStart(2, '0')}-tab`);
            const currentStepTabPane = $(`#step${currentStepNumber.toString().padStart(2, '0')}-tab-pane`);
            const prevStepNumber = currentStepNumber - 1;
            const prevStepTab = $(`#step${prevStepNumber.toString().padStart(2, '0')}-tab`);
            const prevStepTabPane = $(`#step${prevStepNumber.toString().padStart(2, '0')}-tab-pane`);

            if (currentStepTab.length > 0 && prevStepTab.length > 0) {
                currentStepTab.removeClass("active");
                currentStepTabPane.removeClass("show active");
                prevStepTab.addClass("active");
                prevStepTabPane.addClass("show active");
            }
            window.scrollTo({ top: 0, behavior: "smooth" });
        }

        const titoliModalita: Record<string, string> = {
            "2": t("messages.DatiSocietaEnte"),
            "3": t("messages.DatiPersonaFisicaGiuridica"),
            "4": t("messages.DatiContitolare"),
            "6": t("messages.DatiSoggettoAmministrato"),
        }; // TODO: i18n

        $("#modalitaAcquisto").on("change", async (e) => {

            const selectValue = $("#modalitaAcquisto").val() as string;
            const idModalitaAcquisto = Number(selectValue);

            console.info("Vecchia modalità :" + this._modalitaAcquistoId + " Nuova modalità " + idModalitaAcquisto);
            // Validazione valore selezionato
            if (isNaN(idModalitaAcquisto) || !selectValue) {
                UI.confirmOneButton("", t("messages.selezionareModalitaAcquistoValida")); // TODO: i18n
                return;
            }
            

            // Conferma se ci sono soggetti già inseriti
            const soggettiPresenti = $("#divElencoSoggettiVenditaAcquisto .soggetto-item").length > 0;
            if (soggettiPresenti) {
                const conferma = await new Promise<boolean>(resolve => {
                    UI.confirm("", t("messages.confirmChangePurchaseMode"), "", resolve);
                });
                if (!conferma) {
                    // ✅ Ripristina il valore precedente e trigghera l'evento change
                    $("#modalitaAcquisto").val(this._modalitaAcquistoId.toString());
                    return;
                }
            }

            try {
                // Salva il valore tramite una chiamata API
                const response = await this.SalvaModalitaAcquisto(idModalitaAcquisto, this._offertaId);

                if (!response) {
                    console.info("Errore durante il salvataggio della modalità di acquisto.");
                    UI.confirmOneButton("", t("messages.errorSavingPurchaseMode")); // Feedback all'utente
                    return;
                }

                // Rimuovi soggetti precedenti
                $("#divElencoSoggettiVenditaAcquisto .soggetto-item").remove();

                this.controllaVisibilitaPulsanteAggiungiSoggetto();

                // Aggiorna attributi modale
                $("#modalSoggettoVenditaAcquisto")
                    .attr("data-modalita-acquisto", selectValue)
                    .attr("data-offerta-id", this._offertaId)
                    .attr("data-vendita-id", this._venditaId);

                // Nascondi tutti i div
                [
                    "#divSoggettiVenditaAcquisto",
                    "#divPerSocieta",
                    "#divPerProcura",
                    "#divInComproprieta",
                    "#divDaTutore"
                ].forEach(sel => $(sel).addClass("d-none"));

                // Mappa delle classi da mostrare in base al valore di selectValue
                const visibilityMap: Record<string, string[]> = {
                    "2": ["#divSoggettiVenditaAcquisto", "#divPerSocieta"],
                    "3": ["#divSoggettiVenditaAcquisto", "#divPerProcura"],
                    "4": ["#divSoggettiVenditaAcquisto", "#divInComproprieta"],
                    "6": ["#divSoggettiVenditaAcquisto", "#divDaTutore"]
                };

                //Imposta il titolo della modale in base alla modalità di acquisto selezionata
                const titolo = titoliModalita[selectValue] || t("messages.selectValidPurchaseMode");
                $("#SoggettiVenditaAcquistoLabel").text(titolo);

                //Mostra i div corrispondenti al valore selezionato
                if (visibilityMap[selectValue]) {
                    visibilityMap[selectValue].forEach(selector => $(selector).removeClass("d-none"));
                }
                //controllo se è presente la PIA e nel caso la rimuovo perchè
                //con il cambio di modalità di acquisto la PIA deve essere nuovamente generata
                const piaCancellata: boolean = await DeleteDocumentoGaraByOffertaIdAndTipo(this._offertaId, "PIA");

                if (piaCancellata) {
                    $("#divUploadFilePia").removeClass("d-none");
                    $("#OffertaFilePia").val("").attr("required", "required");
                    $("#divFilePia").addClass("d-none");
                    UI.confirmOneButton("", t("messages.piaDeletedChangeMode"));
                }
            } catch (error) {
                console.error("Errore:", error);
                UI.confirmOneButton("", t("messages.errorSaving")); // Feedback all'utente
            }
        });

        $("#modalSoggettoVenditaAcquisto")
            .attr("data-modalita-acquisto", this._modalitaAcquistoId)
            .attr("data-offerta-id", that._offertaId)
            .attr("data-vendita-id", that._venditaId);

        // Attivo il modal per la gestione dei comproprietari
        await this._SoggettoVenditaAcquistoModal.activate();

        /*********************************************************************************************************/
        /***************************************** STEP 3 ********************************************************/
        /*********************************************************************************************************/

        $("#OffertaImportoCauzione").on("blur", async (e) => {
            const offertaImportoCauzione = $("#OffertaImportoCauzione").val() as string;
            const offertaImportoCauzioneNumber = parseFloat(offertaImportoCauzione.replace(/\./g, ''));
            if (isNaN(offertaImportoCauzioneNumber) || offertaImportoCauzione === "") {
                UI.confirmOneButton("", t("messages.enterCautionAmount"));
                return;
            }
            const offertaCauzioneMinima = $("#OffertaCauzioneMinima").val() as string;
            const offertaCauzioneMinimaNumber = parseFloat(offertaCauzioneMinima.replace(/\./g, ''));
            if (!isNaN(offertaCauzioneMinimaNumber) && offertaCauzioneMinima != "" && offertaCauzioneMinimaNumber > offertaImportoCauzioneNumber) {
                const amount = offertaCauzioneMinimaNumber.toLocaleString('it-IT', {
                    style: 'currency',
                    currency: 'EUR',
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0
                });
                UI.confirmOneButton(t("common.attention"), t("messages.amountLowerThanMinCaution", { amount }), "", function (result) {
                    if (result) {
                        $("#OffertaImportoCauzione").val("");
                    }
                });
            }
        })

        $(".delete-contabile").on("click", async function (e) {

            e.preventDefault();
            const allegatoId = $(this).data("id");
            if (!allegatoId) return;

            UI.confirm(t("common.confirm"), t("messages.confirmDelete"), "", async (result) => {

                console.log("Conferma eliminazione allegato gara:", result);
                if (!result) {
                    return;
                }

                await DeleteDocumentoGara(allegatoId);
                $(this).closest(".allegatoGara-item").remove();

                // Controlla se ci sono altri allegati
                if ($(".allegatoGara-item").length === 0) {
                    $("#divUploadFileContabile").removeClass("d-none");
                    $("#OffertaFileContabile").val("").attr("required", "required");
                }

                UI.confirmOneButton("", t("messages.attachmentDeletedSuccess"));
            });
        });

        // ✅ Validazione file al momento della selezione
        $("#OffertaFileContabile").on("change", function () {
            const fileInput = this as HTMLInputElement;
            if (fileInput.files && fileInput.files.length > 0) {
                validateAndShowFileError(fileInput, fileInput.files[0]);
            }
        });


        /*********************************************************************************************************/
        /***************************************** STEP 4 ********************************************************/
        /*********************************************************************************************************/

        $(".btnDowloadPia").on("click", async function (e) {
            e.preventDefault();
            const offertaId = $(this).data("idofferta");
            if (!offertaId) return;
            await that.GeneraPdfPIA(offertaId);
        })

        // ✅ Validazione file PIA mascherato con bordo rosso
        $("#OffertaFilePia").on("change", function () {
            const fileInput = this as HTMLInputElement;
            if (fileInput.files && fileInput.files.length > 0) {
                validateMaskedFileInputWithBorder(fileInput, fileInput.files[0], "filePiaName");
            }
        });

        // ✅ Validazione file AntiRiciclaggio mascherato con bordo rosso
        $("#OffertaFileAntiRiciclaggio").on("change", function () {
            const fileInput = this as HTMLInputElement;
            if (fileInput.files && fileInput.files.length > 0) {
                validateMaskedFileInputWithBorder(fileInput, fileInput.files[0], "fileAntiName");
            }
        });


        // ✅ Validazione file al momento della selezione
        $("#OffertaFileAltroDocumento").on("change", function () {
            const fileInput = this as HTMLInputElement;
            if (fileInput.files && fileInput.files.length > 0) {
                validateAndShowFileError(fileInput, fileInput.files[0]);
            }
        });

        $(".delete-pia").on("click", async function (e) {
            e.preventDefault();
            const allegatoId = $(this).data("id");
            if (!allegatoId) return;

            UI.confirm(t("common.confirm"), t("messages.confirmDelete"), "", async (result) => {

                console.log("Conferma eliminazione allegato gara:", result);
                if (!result) {
                    return;
                }

                await DeleteDocumentoGara(allegatoId);

                $(this).closest(".allegatoPia-item").remove();

                // Controlla se ci sono altri allegati
                if ($(".allegatoPia-item").length === 0) {
                    $("#divUploadFilePia").removeClass("d-none");
                    $("#OffertaFilePia").val("").attr("required", "required");

                    // ✅ Reset snapshot
                    that._snapshotDatiOfferta = null;
                    that._existePIA = false;
                }
                UI.confirmOneButton("", t("messages.attachmentDeletedSuccess"));
            });
        });

        $(".delete-antiriciclaggio").on("click", async function (e) {
            e.preventDefault();
            const allegatoId = $(this).data("id");
            if (!allegatoId) return;

            UI.confirm(t("common.confirm"), t("messages.confirmDelete"), "", async (result) => {

                console.log("Conferma eliminazione allegato gara:", result);
                if (!result) {
                    return;
                }

                await DeleteDocumentoGara(allegatoId);

                $(this).closest(".allegatoAntiRiciclaggio-item").remove();

                // Controlla se ci sono altri allegati
                if ($(".allegatoAntiRiciclaggio-item").length === 0) {
                    $("#divUploadFileAntiRiciclaggio").removeClass("d-none");
                    $("#OffertaFileAntiRiciclaggio").val("").attr("required", "required");
                }
                UI.confirmOneButton("", t("messages.attachmentDeletedSuccess"));
            });
        });

        $(".delete-altrodocumento").on("click", async function (e) {
            e.preventDefault();
            const allegatoId = $(this).data("id");
            if (!allegatoId) return;

            UI.confirm(t("common.confirm"), t("messages.confirmDelete"), "", async (result) => {

                console.log("Conferma eliminazione allegato gara:", result);
                if (!result) {
                    return;
                }

                await DeleteDocumentoGara(allegatoId);

                $(this).closest(".allegatoAltroDocumento-item").remove();

                // Controlla se ci sono altri allegati
                if ($(".allegatoAltroDocumento-item").length === 0) {
                    $("#divUploadFileAltroDocumento").removeClass("d-none");
                    $("#OffertaFileAltroDocumento").val("");
                }
                UI.confirmOneButton("", t("messages.attachmentDeletedSuccess"));
            });
        });

        /*********************************************************************************************************/
        /***************************************** STEP 5 ********************************************************/
        /*********************************************************************************************************/

        $("#btnInviaOfferta").on("click", async function (e) {

            e.preventDefault();
            const offertaId = that._offertaId;
            if (!offertaId) return;

            UI.confirmWithButtonOkCustom("", t("messages.aboutToSendOffer"), t("offerta.sendOffer"), "", async (result) => {
                if (!result) {
                    return;
                }

                const offerta: any = await that.InviaOfferta();
                if (offerta) {

                    UI.confirmOneButtonCustom(t("messages.proposalSent"), t("messages.proposalReceivedMessage"), t("messages.backToReservedArea"), "", function (result) {
                        if (result) {
                            window.location.href = window.BaseUrlWeb + "offerta-asta-dinamica-" + that._venditaId;
                        }
                    });



                } else {
                    UI.confirmOneButton("", t("messages.errorSendingOffer"));
                }
            })

        });
        return Promise.resolve();
    }

    /********************************************************************************************************/
    /*************************************** STEP 1 DATI OFFERENTE ******************************************/
    /********************************************************************************************************/

    private async ValidaStep01(): Promise<boolean> {

        //PRIMA CONTROLLO CHE IL PROFILO SIA COMPLETO
        const isUpdated = await this._tabProfilo.updateProfile(true); // Richiama il metodo updateProfile
        if (!isUpdated)
            return false;

        // Controlla se il documento utente è stato caricato
        const existDocUtente = await this._documentoModal.checkDocumentoUtente(this.UserId);
        if (!existDocUtente) {
            UI.confirmOneButton("", t("messages.needUploadUserDocument"));
            return false;
        }

        return true;
    }

    /********************************************************************************************************/
    /*************************************** STEP 2 MODALITA DI ACQUISTO ************************************/
    /********************************************************************************************************/
    private async ValidaStep02(): Promise<boolean> {
        // Controlla se il documento utente è stato caricato
        const selectValue = $("#modalitaAcquisto").val() as string;
        const idModalitaAcquisto = Number(selectValue);
        if (isNaN(idModalitaAcquisto) || selectValue == null || selectValue === "") {

            UI.confirmOneButton("", t("messages.selectValidPurchaseMode"));
            return false;
        } else {
            if (idModalitaAcquisto != 1) {
                //Controllo se è presente almeno un soggetto acquirente
                const esisteAlmenoUnSoggetto = $(".soggetto-item").length > 0;
                if (!esisteAlmenoUnSoggetto) {
                    UI.confirmOneButton("", t("messages.addSoggettoAcquisto"));
                    return false;
                }
            }
        }

        return true;
    }

    private async SalvaModalitaAcquisto(idModalitaAcquisto: number, offertaId: number): Promise<boolean> {
        console.info(idModalitaAcquisto + " - " + offertaId);

        var url = window.BaseUrlWebApi + "AstaDinamica/SalvaModalitaAcquisto?idModalitaAcquisto=" + idModalitaAcquisto + "&offertaId=" + offertaId;
        try {
            const response = await this.auth.fetchWithAuth("GET " + url, {
                cache: "no-cache",
                headers: { 'content-type': 'application/json' },
            });

            if (response.size != 0) {
                const errorText = await response.message();
                throw new Error(`Errore durante il salvataggio della modalità di acquisto: ${errorText}`);
            }

            console.log("Modalità di acquisto salvata con successo.");
            return true;

        } catch (error) {
            console.info("Errore durante il salvataggio della modalità di acquisto", error);
            return false;
        }

    }

    private async DeleteSoggettoVenditaAcquisto(id: number): Promise<any> {
        var url = window.BaseUrlWebApi + "SoggettoVenditaAcquisto/Delete?id=" + id;
        try {
            const response = await this.auth.fetchWithAuth("DELETE " + url, {
                cache: "no-cache",
                headers: { 'content-type': 'application/json' },
            });

            if (!response.success) {
                const errorText = await response.message();
                throw new Error(`Errore durante la cancellazione: ${errorText}`);
            }

            console.log("Soggetto cancellato con successo.");

        } catch (error) {
            console.info("Errore durante la cancellazione del soggetto:", error);
            return;
        }

        return true;

    }


    private async loadStep2(): Promise<void> {

        // ✅ Controlla visibilità iniziale
        this.controllaVisibilitaPulsanteAggiungiSoggetto();

        // ✅ ASCOLTA gli eventi per aggiornare quando cambia qualcosa
        $(document).off("soggettoAggiunto soggettoEliminato"); // Rimuovi listener precedenti

        $(document).on("soggettoAggiunto soggettoEliminato", () => {
            console.info("Evento soggetto modificato, ricontrollo visibilità pulsante");
            this.controllaVisibilitaPulsanteAggiungiSoggetto();
        });
    }


    private controllaVisibilitaPulsanteAggiungiSoggetto(): void {
        // Controlla se ci sono soggetti già inseriti
        const numSoggetti = $("#divElencoSoggettiVenditaAcquisto .soggetto-item").length;

        // Recupera l'ID modalità acquisto
        const idModalitaAcquisto = parseInt($("#modalitaAcquisto").val() as string) || 0;

        // Se c'è almeno un soggetto E la modalità NON è "In Comproprietà" (4)
        // nascondi il pulsante "Aggiungi"

        if (idModalitaAcquisto == 1) {
            $(".btnAggiungiSoggetto").addClass("d-none");
        } else if (numSoggetti > 0 && idModalitaAcquisto !== 4) {
            $(".btnAggiungiSoggetto").addClass("d-none");

            // Nascondi tutti i div
            [
                "#divPerSocieta",
                "#divPerProcura",
                "#divInComproprieta",
                "#divDaTutore"
            ].forEach(sel => $(sel).addClass("d-none"));

            console.info(`Pulsante "Aggiungi Soggetto" nascosto: ${numSoggetti} soggetti presenti, modalità ${idModalitaAcquisto}`);
        } else {
            $(".btnAggiungiSoggetto").removeClass("d-none");
        }
    }

    /********************************************************************************************************/
    /*************************************** STEP 3 CAUZIONE E RESTITUZIONE *********************************/
    /********************************************************************************************************/
    private async ValidaStep03(): Promise<boolean> {
        this.addValidationFormStep3();
        try {
            // Validazione del form
            this.onSubmitValidator();
            if (!this.theFormStep3.checkValidity()) {
                this.theFormStep3.classList.add('was-validated');
                return false;
            }

            const submitResult = await this.submitStep3();
            // ✅ Controlla se il submit è andato a buon fine
            if (!submitResult) {
                return false;
            }
            return true;
        } catch (error) {
            // Gestisci eventuali errori se necessario
            console.error("Errore nel submitStep3:", error);
            return false;
        }
    }

    private addValidationFormStep3(): void {
        const that = this;
        const form = this.theFormStep3;
        // Rimuove la classe di validazione quando l'utente modifica i campi
        form.addEventListener("input", () => {
            form.classList.remove("was-validated");
        });

        const inputValidator = (inputElement: HTMLInputElement): validation.ValidationResult => {
            if (!$(inputElement).is(":visible")) {
                return { ok: true, error: "" };
            }
            const inputValue = $(inputElement).val() as string;
            const isValid = inputValue.length > 0;

            return {
                ok: isValid,
                error: isValid ? "" : t("validation.required")
            };
        }

        // Imposta i validatori sui campi testo
        validation.setValidatorOnInput("OffertaImportoCauzione", inputValidator);
        validation.setValidatorOnInput("OffertaIntestatarioCC", inputValidator);
        validation.setValidatorOnInput("OffertaIstitutoCredito", inputValidator);
        validation.setValidatorOnInput("OffertaIban", inputValidator);
        validation.setValidatorOnInput("OffertaFileContabile", inputValidator);
        // validation.setValidatorOnInput("note", inputValidator);


        // Validazione al submit
        this.onSubmitValidator = async () => {
            validation.validate("OffertaImportoCauzione", inputValidator);
            validation.validate("OffertaIntestatarioCC", inputValidator);
            validation.validate("OffertaIstitutoCredito", inputValidator);
            validation.validate("OffertaIban", inputValidator);
            validation.validate("OffertaFileContabile", inputValidator);
        };

    }

    private onSubmitValidator: () => void = async () => {
    }

    private async submitStep3(): Promise<boolean> {

        //Salva allegato Cauzione
        const fileInputCauzione = document.getElementById("OffertaFileContabile") as HTMLInputElement;
        if (fileInputCauzione && fileInputCauzione.files && fileInputCauzione.files.length > 0) {
            const tipoDocumento = "CBL";

            //const resultSaveAllegato: any = await this.SalvaDocumentoGara(tipoDocumento, fileInputCauzione);
            //console.log("Result Save Allegato Cauzione:", resultSaveAllegato)

            //if (!resultSaveAllegato.success) {
            //    UI.confirmOneButton("", resultSaveAllegato.message || t("messages.errorSavingDocument"));
            //    return false;
            //}

            const resultSaveAllegato: any = await this.SalvaDocumentoGara(tipoDocumento, fileInputCauzione);
            console.log("Result Save Allegato Cauzione:", resultSaveAllegato)

            if (!resultSaveAllegato.success) {

                // ✅ Estrai il messaggio (supporta sia JSON che stringa semplice)
                let errorMessage = t("messages.errorUploadingFile");
                try {
                    const errorData = typeof resultSaveAllegato.message === "string"
                        ? JSON.parse(resultSaveAllegato.message)
                        : resultSaveAllegato.message;
                    errorMessage = errorData?.Message || resultSaveAllegato.message || errorMessage;
                } catch {
                    errorMessage = resultSaveAllegato.message || errorMessage;
                }

                UI.confirmOneButton(t("common.atAttention"), errorMessage, "", function (result) {
                    if (result) {
                        $(fileInputCauzione).val("");
                        clearFileError(fileInputCauzione);
                        // oppure
                        clearCustomFileError(fileInputCauzione);
                    }
                });

                return false;
            }

            const item = resultSaveAllegato.data;
            // Nascondo il campo di upload se il file è stato caricato correttamente
            if (item && item.Id) {
                $("divUploadFileContabile").addClass("d-none");
                $("#OffertaFileContabile").val("").removeAttr("required");
            }

            // Aggiungo l'allegato alla lista degli allegati
            // $("#listaAllegatiCauzione").append(rowAllegato);
            // Aggiungo l'allegato alla lista degli allegati
            const divFileCauzione = document.getElementById("divFileCauzione");
            if (!divFileCauzione) return false;

            // Template per la riga dell'allegato
            const id = item.Allegato.Id;
            const path = item.Allegato.Path;
            const descrizione = item.Allegato.Descrizione;
            //const tipo = item.Allegato.Tipo;

            const rowAllegato = `
                <div class="allegatoGara-item d-flex align-items-center gap-2">
                    <div class="d-flex gap-1 align-items-center">
                        <span class="material-symbols-outlined text-secondary">description</span>
                        <a class="d-flex flex-column lh-sm" href="../Asta/ScaricaDocumentoGara?data=${path}&nomeDoc=${descrizione}">
                            <span class="fw-bold text-dark">${descrizione}</span>
                        </a>
                    </div>
                    <div role="button" id="btnEliminaDocCauzione" type="button" class="text-danger delete-allegato"
                            data-id="${id}" aria-label="${t("messages.delete")}" title="${t("messages.delete")}">
                        <span class="material-symbols-outlined">delete</span>
                    </button>
                </div>
            `;

            divFileCauzione.insertAdjacentHTML("beforeend", rowAllegato);

            //nascondo il campo di upload
            $("#divUploadFileContabile").addClass("d-none");
            $("#OffertaFileContabile").val("").removeAttr("required");

            //Visualizzo il div che contiene il file caricato
            $("#divFileCauzione").removeClass("d-none");

            // Aggiungo l'evento di cancellazione al nuovo bottone
            const btnElimina = divFileCauzione.querySelector("#btnEliminaDocCauzione") as HTMLElement;
            if (btnElimina) {
                btnElimina.addEventListener("click", async (e) => {
                    e.preventDefault();
                    const el = e.currentTarget as HTMLElement; // Recuoera il bottone cliccato
                    const allegatoId = el.getAttribute("data-id");
                    console.log("AllegatoId da eliminare:", allegatoId);
                    if (!allegatoId) return;
                    UI.confirm(t("common.confirm"), t("messages.confirmDelete"), "", async (result) => {

                        console.log("Conferma eliminazione allegato gara:", result);
                        if (!result) {
                            return;
                        }

                        await DeleteDocumentoGara(parseInt(allegatoId));

                        if (el && el.closest) {
                            el.closest(".allegatoGara-item")?.remove();
                        }

                        // Controlla se ci sono altri allegati
                        if ($(".allegatoGara-item").length === 0) {
                            $("#divUploadFileContabile").removeClass("d-none");
                            $("#OffertaFileContabile").val("").attr("required", "required");
                        }
                        UI.confirmOneButton("", t("messages.attachmentDeletedSuccess"));
                    });
                });
            }
        }

        //Salva DATI CAUZIONE
        if (!this._allegatiVerificati) {

            $("#formStep3")
                .serializeArray()
                .forEach((field) => {
                    this.formDataStep3[field.name] = field.value;
                });

            var offertaCauzione: string = this.formDataStep3["OffertaAstaDinamica.ImportoCauzione"] as string;
            if (offertaCauzione && offertaCauzione.includes(".")) {
                offertaCauzione = offertaCauzione.replace(/\./g, '');
                this.formDataStep3["OffertaAstaDinamica.ImportoCauzione"] = offertaCauzione;
            }

            console.log("Dati Step 3:", this.formDataStep3);
            const url = window.BaseUrlWebApi + "AstaDinamica/SalvaCauzioneRestituzione";
            try {
                await this.auth.fetchWithAuth("POST " + url, {
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        Id: this._offertaId,
                        ImportoCauzione: parseFloat(this.formDataStep3["OffertaAstaDinamica.ImportoCauzione"]),
                        IntestatarioContoCorrente: this.formDataStep3["OffertaAstaDinamica.IntestatarioContoCorrente"],
                        IstitutoDiCredito: this.formDataStep3["OffertaAstaDinamica.IstitutoDiCredito"],
                        IBAN: this.formDataStep3["OffertaAstaDinamica.IBAN"]
                    }),

                });

                console.log("salvataggio avvenuto con successo.");
            } catch (error) {
                console.error("Errore durante il salvataggio:", error);
                //UI.confirmOneButton("", t("messages.errorSavingDocument"));
                return false;
            }
        }

        return true;
    }

    private async SalvaDocumentoGara(tipoDocumento: string, fileInput: any, descrizione?: string): Promise<any> {
        if (fileInput?.files?.length) {
            const file = fileInput.files[0];
            const maxSize = 4 * 1024 * 1024; // 4 MB in bytes

            // ✅ Controllo dimensione file
            if (file.size > maxSize) {
                // Mostra errore sotto l'input
                showFileError(fileInput, t("messages.fileTooLargeWithSize", { size: formatFileSize(file.size) }));
                return {
                    success: false,
                    message: t("messages.fileTooLargeMax4MB")
                };
            }

            // ✅ Rimuovi eventuali errori precedenti
            clearFileError(fileInput);

            const data = {
                UserId: this.userInfo.anagraficaId,
                VenditaId: Number($("#hdVenditaId").val()),
                Tipo: tipoDocumento,
                OffertaId: Number($("#hdOffertaId").val()),
                file: fileInput.files[0],
                descrizione: descrizione,
            };

            try {
                const allegatoGara: any = await uploadDocumentoGara(data);

                console.info("Allegato Gara:", allegatoGara.AllegatoId);

                return allegatoGara;
            } catch (error) {
                return { success: false, message: t("messages.errorUploadingDocument") };
            }
        }
    }

    /********************************************************************************************************/
    /*************************************** STEP 4 documenti proposta **************************************/
    /********************************************************************************************************/

    /**
     * Controlla se ci sono modifiche quando si passa allo step 4
     * e gestisce la cancellazione della PIA se necessario
     */
    private async controllaModifichePerStep4(): Promise<void> {
        const esistePIA = this.verificaEsistenzaPIA();
        console.log("🔵 controllaModifichePerStep4 - Esiste PIA:", esistePIA);
        console.log("🔵 controllaModifichePerStep4 - Snapshot precedente:", this._snapshotDatiOfferta);

        if (esistePIA) {
            // ✅ Se non esiste snapshot, crealo ADESSO (prima chiamata dopo riapertura wizard)
            // Questo garantisce che i dati del form siano già caricati
            if (!this._snapshotDatiOfferta) {
                this._snapshotDatiOfferta = await this.creaSnapshotDatiOfferta();
                console.log("✅ Snapshot creato al primo accesso step 4 (PIA esistente):", this._snapshotDatiOfferta);
                return; // Non confrontare al primo accesso, solo salva lo snapshot
            }

            // ✅ Confronta solo se esiste già uno snapshot salvato
            const ciSonoModifiche = await this.verificaModifiche();
            console.log("🔵 controllaModifichePerStep4 - Ci sono modifiche:", ciSonoModifiche);

            if (ciSonoModifiche) {
                // ✅ Mostra avviso e cancella la PIA
                const conferma = await new Promise<boolean>(resolve => {
                    UI.confirmOneButton(
                        t("messages.changesDetected"),
                        t("messages.changesDetectedMessage"),
                        "",
                        resolve
                    );
                });

                if (conferma) {
                    await this.rimuoviPIAEsistente();
                }
            }
        }
        // ✅ Se non esiste PIA, non fare nulla (lo snapshot verrà creato dopo il caricamento)
    }

    private async ValidaStep04(): Promise<boolean> {
        this.addValidationFormStep4();
        let _ = this.spinner.spin();
        try {
            // Validazione del form
            this.onSubmitValidator();
            if (!this.theFormStep4.checkValidity()) {
                this.theFormStep4.classList.add('was-validated');
                return false;
            }

            const submitResult = await this.submitStep4();
            // ✅ Controlla se il submit è andato a buon fine
            if (!submitResult) {
                return false;
            }
            return true;
        } catch (error) {
            // Gestisci eventuali errori se necessario
            console.error("Errore nel submitStep4:", error);
            return false;
        } finally {
            this.spinner.stop();
        }
    }

    private addValidationFormStep4(): void {
        const that = this;
        const form = this.theFormStep4;
        // Rimuove la classe di validazione quando l'utente modifica i campi
        form.addEventListener("input", () => {
            form.classList.remove("was-validated");
        });

        const inputValidator = (inputElement: HTMLInputElement): validation.ValidationResult => {
            if (!$(inputElement).is(":visible")) {
                return { ok: true, error: "" };
            }
            const inputValue = $(inputElement).val() as string;
            const isValid = inputValue.length > 0;

            return {
                ok: isValid,
                error: isValid ? "" : t("validation.required")
            };
        }

        // ✅ Validatore personalizzato per i file
        const fileValidator = (inputElement: HTMLInputElement): validation.ValidationResult => {
            const $input = $(inputElement);
            const files = inputElement.files;

            // Controlla se è richiesto e non è presente
            if ($input.prop("required") && (!files || files.length === 0)) {
                showCustomFileError(inputElement, t("messages.documentNotUploaded"));
                return { ok: false, error: t("messages.documentNotUploaded") };
            }

            // Se c'è un file, controlla la dimensione
            if (files && files.length > 0) {
                const file = files[0];
                const maxSize = 4 * 1024 * 1024; // 4 MB

                if (file.size > maxSize) {
                    const errorMsg = t("messages.fileTooLargeWithSize", { size: formatFileSize(file.size) });
                    showCustomFileError(inputElement, errorMsg);
                    return { ok: false, error: errorMsg };
                }

                // File valido, rimuovi errori
                clearCustomFileError(inputElement);
            }

            return { ok: true, error: "" };
        };


        // Imposta i validatori sui file input
        validation.setValidatorOnInput("OffertaFilePia", fileValidator);
        validation.setValidatorOnInput("OffertaFileAntiRiciclaggio", fileValidator);

        // ✅ Aggiungi validazione al cambio file
        $("#OffertaFilePia, #OffertaFileAntiRiciclaggio").on("change", function () {
            const fileInput = this as HTMLInputElement;
            fileValidator(fileInput);
        });

        // Validazione al submit
        this.onSubmitValidator = async () => {
            validation.validate("OffertaFilePia", fileValidator);
            validation.validate("OffertaFileAntiRiciclaggio", fileValidator);
        };

    }

    private async GeneraPdfPIA(offertaId: number): Promise<void> {
        let _ = this.spinner.spin();
        const url = window.BaseUrlWebApi + "AstaDinamica/GeneraPdfPIA?offertaId=" + offertaId;
        try {
            const response = await this.auth.fetchWithAuth("GET " + url, {
                cache: "no-cache",
                headers: { 'content-type': 'application/json' },
            });

            if (!response) {
                throw new Error(t("messages.errorGeneratingPDF"));
            }

            const blob = await response;
            const downloadUrl = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = downloadUrl;
            a.download = "PropostaDiAcquisto.pdf";
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(downloadUrl);
        } catch (error) {
            console.info("Errore durante la generazione del pdf:", error);
            return;
        } finally {
            this.spinner.stop();
        }
    }

    private async submitStep4(): Promise<Boolean> {
        try {
            const fileInputPia = document.getElementById("OffertaFilePia") as HTMLInputElement;
            if (fileInputPia && fileInputPia.files && fileInputPia.files.length > 0) {
                const tipoDocumento = "PIA";

                const resultSaveAllegato: any = await this.SalvaDocumentoGara(tipoDocumento, fileInputPia);
                console.log("Result Save Allegato Cauzione:", resultSaveAllegato)

                if (!resultSaveAllegato.success) {

                    // ✅ Estrai il messaggio (supporta sia JSON che stringa semplice)
                    let errorMessage = t("messages.errorUploadingFile");
                    try {
                        const errorData = typeof resultSaveAllegato.message === "string"
                            ? JSON.parse(resultSaveAllegato.message)
                            : resultSaveAllegato.message;
                        errorMessage = errorData?.Message || resultSaveAllegato.message || errorMessage;
                    } catch {
                        errorMessage = resultSaveAllegato.message || errorMessage;
                    }

                    const errorBody = `<span class="text-danger">${fileInputPia.files[0].name}</span>: ${errorMessage}`;

                    UI.confirmOneButton(t("common.atAttention"), errorBody, "", (result) => {
                        if (result) {
                            this.resetFileInput(fileInputPia, "filePiaName");
                        }
                    });

                    return false;
                }

                const item = resultSaveAllegato.data;
                // Nascondo il campo di upload se il file è stato caricato correttamente
                if (item && item.Allegato.Id) {
                    $("#divUploadFilePia").addClass("d-none");
                    $("#OffertaFilePia").val("").removeAttr("required");
                }

                // Aggiungo l'allegato alla lista degli allegati
                const divFilePia = document.getElementById("divFilePia");
                if (!divFilePia) return false;

                // Template per la riga dell'allegato
                const id = item.Allegato.Id;
                const path = item.Allegato.Path;
                const descrizione = item.Allegato.Descrizione;

                const rowAllegato = `
                <div class="allegatoPia-item mb-4 position-relative">
                    <div class="">
                        <div class="d-flex align-items-center gap-2">
                            <div class="d-flex gap-1 align-items-center">
                                <span class="material-symbols-outlined text-secondary">description</span>
                                <a href="../Asta/ScaricaDocumentoGara?data=${path}&nomeDoc=${descrizione}" class="fw-bold text-dark">
                                ${descrizione}
                                </a>
                            </div>
                            <div class="d-flex gap-2 align-items-center">
                                <div role="button" id="btnEliminaDocPia" type="button" class="text-danger delete-pia"
                                        data-id="${id}" aria-label="${t("common.delete")}" title="${t("common.delete")}">
                                    <span class="material-symbols-outlined md-18">delete</span>
                                </div>
                            </div> 

                        </div>
                    </div>
                </div>
            `;

                divFilePia.insertAdjacentHTML("beforeend", rowAllegato);

                //Visualizzo il div che contiene il file caricato
                $("#divFilePia").removeClass("d-none");

                // ✅ Salva snapshot dopo il caricamento della PIA
                this._snapshotDatiOfferta = await this.creaSnapshotDatiOfferta();
                this._existePIA = true;
                console.log("✅ Snapshot salvato dopo caricamento PIA:", this._snapshotDatiOfferta);

                // Aggiungo l'evento di cancellazione al nuovo bottone
                const btnEliminaPia = divFilePia.querySelector("#btnEliminaDocPia") as HTMLElement;
                if (btnEliminaPia) {
                    btnEliminaPia.addEventListener("click", async (e) => {
                        e.preventDefault();
                        const el = e.currentTarget as HTMLElement; // Recuoera il bottone cliccato
                        const allegatoId = el.getAttribute("data-id");
                        console.log("AllegatoId da eliminare:", allegatoId);
                        if (!allegatoId) return;
                        UI.confirm(t("common.confirm"), t("messages.confirmDelete"), "", async (result) => {

                            console.log("Conferma eliminazione allegato gara:", result);
                            if (!result) {
                                return;
                            }

                            await DeleteDocumentoGara(parseInt(allegatoId));

                            if (el && el.closest) {
                                el.closest(".allegatoPia-item")?.remove();
                            }

                            // Controlla se ci sono altri allegati
                            if ($(".allegatoPia-item").length === 0) {
                                $("#divUploadFilePia").removeClass("d-none");
                                $("#OffertaFilePia").val("").attr("required", "required");
                            }
                            UI.confirmOneButton("", t("messages.attachmentDeletedSuccess"));
                        });
                    });
                }
            }

            const fileInputAntiRiciclaggio = document.getElementById("OffertaFileAntiRiciclaggio") as HTMLInputElement;
            if (fileInputAntiRiciclaggio && fileInputAntiRiciclaggio.files && fileInputAntiRiciclaggio.files.length > 0) {
                const tipoDocumento = "ARIC";

                const resultSaveAllegato: any = await this.SalvaDocumentoGara(tipoDocumento, fileInputAntiRiciclaggio);
                console.log("Result Save Allegato Anti riciclaggio:", resultSaveAllegato)

                if (!resultSaveAllegato.success) {

                    // ✅ Estrai il messaggio (supporta sia JSON che stringa semplice)
                    let errorMessage = t("messages.errorUploadingFile");
                    try {
                        const errorData = typeof resultSaveAllegato.message === "string"
                            ? JSON.parse(resultSaveAllegato.message)
                            : resultSaveAllegato.message;
                        errorMessage = errorData?.Message || resultSaveAllegato.message || errorMessage;
                    } catch {
                        errorMessage = resultSaveAllegato.message || errorMessage;
                    }

                    const errorBody = `<span class="text-danger">${fileInputAntiRiciclaggio.files[0].name}</span>: ${errorMessage}`;

                    UI.confirmOneButton(t("common.atAttention"), errorBody, "", (result) => {
                        if (result) {
                            this.resetFileInput(fileInputAntiRiciclaggio, "fileAntiName");
                        }
                    });

                    return false;
                }

                const item = resultSaveAllegato.data;
                // Nascondo il campo di upload se il file è stato caricato correttamente
                if (item && item.Allegato.Id) {
                    $("#divUploadFileAntiRiciclaggio").addClass("d-none");
                    $("#OffertaFileAntiRiciclaggio").val("").removeAttr("required");
                }

                // Aggiungo l'allegato alla lista degli allegati
                // $("#listaAllegatiCauzione").append(rowAllegato);
                // Aggiungo l'allegato alla lista degli allegati
                const divFileAntiRiciclaggio = document.getElementById("divFileAntiRiciclaggio");
                if (!divFileAntiRiciclaggio) return false;

                // Template per la riga dell'allegato
                const id = item.Allegato.Id;
                const path = item.Allegato.Path;
                const descrizione = item.Allegato.Descrizione;

                const rowAllegato = `
                <div class="allegatoAntiRiciclaggio-item mb-4 position-relative">
                    <div class="">
                        <div class="d-flex align-items-center gap-2">
                            <div class="d-flex gap-1 align-items-center">
                                <span class="material-symbols-outlined text-secondary">description</span>
                                <a href="~/Asta/ScaricaDocumentoGara?data=${path}&nomeDoc=${descrizione}" class="fw-bold text-dark">
                                ${descrizione}
                                </a>
                            </div>
                            <div class="d-flex gap-2 align-items-center">
                                <div role="button" id="btnEliminaDocPia" type="button" class="text-danger delete-pia"
                                        data-id="${id}" aria-label="${t("common.delete")}" title="${t("common.delete")}">
                                    <span class="material-symbols-outlined md-18">delete</span>
                                </div>
                            </div> 

                        </div>
                    </div>
                </div>
            `;

                divFileAntiRiciclaggio.insertAdjacentHTML("beforeend", rowAllegato);

                //Visualizzo il div che contiene il file caricato
                $("#divFileAntiRiciclaggio").removeClass("d-none");

                // Aggiungo l'evento di cancellazione al nuovo bottone
                const btnEliminaAntiRiciclaggio = divFileAntiRiciclaggio.querySelector("#btnEliminaDocAntiRiciclaggio") as HTMLElement;
                if (btnEliminaAntiRiciclaggio) {
                    btnEliminaAntiRiciclaggio.addEventListener("click", async (e) => {
                        e.preventDefault();
                        const el = e.currentTarget as HTMLElement; // Recuoera il bottone cliccato
                        const allegatoId = el.getAttribute("data-id");
                        console.log("AllegatoId da eliminare:", allegatoId);
                        if (!allegatoId) return;
                        UI.confirm(t("common.confirm"), t("messages.confirmDelete"), "", async (result) => {

                            console.log("Conferma eliminazione allegato gara:", result);
                            if (!result) {
                                return;
                            }

                            await DeleteDocumentoGara(parseInt(allegatoId));

                            if (el && el.closest) {
                                el.closest(".allegatoAntiRiciclaggio-item")?.remove();
                            }

                            // Controlla se ci sono altri allegati
                            if ($(".allegatoAntiRiciclaggio-item").length === 0) {
                                $("#divUploadFileAntiRiciclaggio").removeClass("d-none");
                                $("#OffertaFileAntiRiciclaggio").val("").attr("required", "required");
                            }
                            UI.confirmOneButton("", t("messages.attachmentDeletedSuccess"));
                        });
                    });
                }
            }

            const fileInputAltroDocumento = document.getElementById("OffertaFileAltroDocumento") as HTMLInputElement;
            if (fileInputAltroDocumento && fileInputAltroDocumento.files && fileInputAltroDocumento.files.length > 0) {
                const tipoDocumento = "ALT";

                const resultSaveAllegato: any = await this.SalvaDocumentoGara(tipoDocumento, fileInputAltroDocumento);
                console.log("Result Save altro allegato:", resultSaveAllegato)

                if (!resultSaveAllegato.success) {
                    // ✅ Estrai il messaggio (supporta sia JSON che stringa semplice)
                    let errorMessage = t("messages.errorUploadingFile");
                    try {
                        const errorData = typeof resultSaveAllegato.message === "string"
                            ? JSON.parse(resultSaveAllegato.message)
                            : resultSaveAllegato.message;
                        errorMessage = errorData?.Message || resultSaveAllegato.message || errorMessage;
                    } catch {
                        errorMessage = resultSaveAllegato.message || errorMessage;
                    }

                    const errorBody = `<span class="text-danger">${fileInputAltroDocumento.files[0].name}</span>: ${errorMessage}`;

                    UI.confirmOneButton(t("common.atAttention"), errorBody, "", function (result) {
                        if (result) {
                            $(fileInputAltroDocumento).val("");
                            clearFileError(fileInputPia);
                        }
                    });
                    return false;
                }

                const item = resultSaveAllegato.data;
                // Nascondo il campo di upload se il file è stato caricato correttamente
                if (item && item.Allegato.Id) {
                    $("#divUploadFileAltroDocumento").addClass("d-none");
                    $("#OffertaFileAltroDocumento").val("");
                }

                // Aggiungo l'allegato alla lista degli allegati
                // $("#listaAllegatiCauzione").append(rowAllegato);
                // Aggiungo l'allegato alla lista degli allegati
                const divFileAltroDocumento = document.getElementById("divFileAltroDocumento");
                if (!divFileAltroDocumento) return false;

                // Template per la riga dell'allegato
                const id = item.Allegato.Id;
                const path = item.Allegato.Path;
                const descrizione = item.Allegato.Descrizione;

                const rowAllegato = `
                <div class="allegatoGara-item mb-4 position-relative">
                    <div class="">
                        <div class="d-flex align-items-center gap-2">
                            <div class="d-flex gap-1 align-items-center">
                                <span class="material-symbols-outlined text-secondary">description</span>
                                <a href="../Asta/ScaricaDocumentoGara?data=${path}&nomeDoc=${descrizione}" class="fw-bold text-dark">
                                ${descrizione}
                                </a>
                            </div>
                            <div class="d-flex gap-2 align-items-center">
                                <div role="button" id="btnEliminaDocPia" type="button" class="text-danger delete-pia"
                                        data-id="${id}" aria-label="${t("common.delete")}" title="${t("common.delete")}">
                                    <span class="material-symbols-outlined md-18">delete</span>
                                </div>
                            </div> 

                        </div>
                    </div>
                </div>
            `;

                divFileAltroDocumento.insertAdjacentHTML("beforeend", rowAllegato);

                //Visualizzo il div che contiene il file caricato
                $("#divFileAltroDocumento").removeClass("d-none");

                // Aggiungo l'evento di cancellazione al nuovo bottone
                const btnEliminaAltroDocumento = divFileAltroDocumento.querySelector("#btnEliminaAltroDocumento") as HTMLElement;
                if (btnEliminaAltroDocumento) {
                    btnEliminaAltroDocumento.addEventListener("click", async (e) => {
                        e.preventDefault();
                        const el = e.currentTarget as HTMLElement; // Recuoera il bottone cliccato
                        const allegatoId = el.getAttribute("data-id");
                        console.log("AllegatoId da eliminare:", allegatoId);
                        if (!allegatoId) return;
                        UI.confirm(t("common.confirm"), t("messages.confirmDelete"), "", async (result) => {

                            console.log("Conferma eliminazione allegato gara:", result);
                            if (!result) {
                                return;
                            }

                            await DeleteDocumentoGara(parseInt(allegatoId));

                            if (el && el.closest) {
                                el.closest(".allegatoAltroDocumento-item")?.remove();
                            }

                            // Controlla se ci sono altri allegati
                            if ($(".allegatoAltroDocumento-item").length === 0) {
                                $("#divUploadFileAltroDocumento").removeClass("d-none");
                            }
                            UI.confirmOneButton("", t("messages.attachmentDeletedSuccess"));
                        });
                    });
                }
            }


        } catch (error) {
            console.error("Errore durante il salvataggio:", error);
            //UI.confirmOneButton("", t("messages.errorSavingDocument"));
            return false;
        }

        return true;
    }

    /********************************************************************************************************/
    /******************************* STEP 5 Riepilogo e Invia Offerta ** ************************************/
    /********************************************************************************************************/

    private async InviaOfferta(): Promise<void> {
        const url = window.BaseUrlWebApi + "AstaDinamica/SaveOffertaCauzionata?offertaId=" + this._offertaId;
        try {
            const offerta = await this.auth.fetchWithAuth("GET " + url, {
                cache: "no-cache",
                headers: { 'content-type': 'application/json' },
            });
            console.log("salvataggio avvenuto con successo.");
            return offerta;
        } catch (error) {

        }
    }

    private async refreshStep5(): Promise<void> {

        const url = window.BaseUrlWebApi + "AstaDinamica/GetOfferta?offertaId=" + this._offertaId;
        try {
            const offerta = await this.auth.fetchWithAuth("GET " + url, {
                cache: "no-cache",
                headers: { 'content-type': 'application/json' },
            });

            console.log("Offerta:", offerta);

            //attiva step1 Profilo
            // Attiva il tab Dati Personali
            let tab = this._tabProfilo;
            await tab.activate();
            console.log("Tab Dati Personali attivato");
            // Attivo il modal per il caricamento del documento utente
            await this._documentoModal.activate();

            // Nascondo il pulsante "Salva Profilo" nella pagina AdPropostaAcquisto
            const context = $("[data-context='AdPropostaAcquisto']");
            if (context.length > 0) {
                const btnSalvaProfilo = $("#btnSalvaProfilo");
                if (btnSalvaProfilo.length > 0) {
                    btnSalvaProfilo.addClass("d-none");
                }
            }

            const offertaAd = offerta.OffertaAstaDinamica;
            const soggetti = offerta.OffertaAstaDinamica.SoggettiVenditaAcquisto;
            const allegati = offerta.OffertaAstaDinamica.Allegati;

            // Recupera i dati dagli step precedenti (esempio)
            const modalitaAcquisto = offertaAd.ModalitaAcquisto;
            const importoCauzione = offertaAd.ImportoCauzione;
            const intestatarioCC = offertaAd.IntestatarioContoCorrente;
            const istitutoDiCredito = offertaAd.IstitutoDiCredito;
            const iban = offertaAd.IBAN;

            for (const soggetto of soggetti) {
                let nominativo = soggetto.Nominativo;
                let quota = soggetto.quota != null ? soggetto.quota : "";
                let documento = soggetto.AllegatoGara.Descrizione;
                let pathdocumento = soggetto.AllegatoGara.Path;
                console.log("soggetto:", soggetto);
                console.log("nominativo:", nominativo);
                console.log("quota:", quota);
                console.log("documento:", documento);
                console.log("pathdocumento:", pathdocumento);
            }

            // Aggiorna i campi dello step 5 nel DOM
            $("#riepilogoModalitaAcquisto").text(modalitaAcquisto);
            $("#riepilogoImportoCauzione").text(UI.formatEuroCurrency(importoCauzione));
            $("#riepilogoIntestatarioCC").text(intestatarioCC);
            $("#riepilogoIstitutoDiCredito").text(istitutoDiCredito);
            $("#riepilogoIban").text(iban?.toUpperCase() || "");

        } catch (error) {
            console.log("Errore durante il recupero dell'offerta:", error);
        }
    }

    /*----------------------------------------------------------------*/
    /*------------------ Metodi helper per la gestione errori --------*/
    /*----------------------------------------------------------------*/

    /*----------------------------------------------------------------*/
    /*------------------ Metodi per tracking modifiche ---------------*/
    /*----------------------------------------------------------------*/

    /**
     * Crea uno snapshot dei dati critici dell'offerta
     */
    private async creaSnapshotDatiOfferta(): Promise<string> {
        // ✅ Normalizza l'importo rimuovendo separatori migliaia per confronto corretto
        const importoCauzioneRaw = $("#OffertaImportoCauzione").val() as string || "";
        const importoCauzioneNormalizzato = importoCauzioneRaw.replace(/\./g, '').replace(/,/g, '.');

        const datiCritici = {
            // Step 1 - Dati profilo (prendi solo i dati essenziali)
            profiloId: this.UserId,
            nomeOfferente: $("#txtNome").val(),
            cognomeOfferente: $("#txtCognome").val(),
            cfOfferente: $("#txtCodiceFiscalePrivato").val(),
            dataNascitaOfferente: $("#txtDataNascita").val(),
            statoNascitaOfferente: $("#ddlStatoNasc").val(),
            idComuneNascidtaOfferente: $("#txtIdComuneNascita").val(),
            luogoNascidtaOfferente: $("#txtLuogoNascitaEstero").val(),
            emailOfferente: $("#txtEmail").val(),
            cellOfferente: $("#txtCellulare").val(),
            statoResOfferente: $("#ddlStatoRes").val(),
            comuneOfferente: $("#txtComune").val(),
            capOfferente: $("#txtCap").val(),
            provinciaOfferente: $("#txtProvincia").val(),
            indirizzoOfferente: $("#txtIndirizzo").val(),

            // Step 2 - Modalità acquisto e soggetti
            modalitaAcquisto: $("#modalitaAcquisto").val(),
            soggetti: await this.recuperaDatiSoggetti(), // ✅ Usa metodo dedicato

            // Step 3 - Dati cauzione (normalizzato per confronto)
            importoCauzione: importoCauzioneNormalizzato,
        };

        // Crea hash/stringa dei dati
        const snapshot = JSON.stringify(datiCritici);
        console.log("📸 Snapshot creato:", datiCritici);
        return snapshot;
    }

    /**
     * Recupera i dati completi dei soggetti (da DOM con data attributes o da API)
     */
    private async recuperaDatiSoggetti(): Promise<any[]> {
        const soggetti: any[] = [];

        //// ✅ OPZIONE A: Leggi da data attributes (se disponibili)
        //$("#divElencoSoggettiVenditaAcquisto .soggetto-item").each(function() {
        //    const $soggetto = $(this);

        //    // Se ci sono data attributes, usali
        //    if ($soggetto.data("nominativo")) {
        //        soggetti.push({
        //            id: $soggetto.attr("id"),
        //            nominativo: $soggetto.data("nominativo") || "",
        //            codiceFiscale: $soggetto.data("cf") || $soggetto.data("codice-fiscale") || "",
        //            tipoSoggetto: $soggetto.data("tipo-soggetto") || "",
        //            quota: $soggetto.data("quota") || ""
        //        });
        //    } else {
        //        // Altrimenti usa solo l'ID (fallback)
        //        soggetti.push({ id: $soggetto.attr("id") });
        //    }
        //});

        // ✅ OPZIONE B: Se non ci sono data attributes, recupera da API
        if (soggetti.length == 0) {
            console.log("📡 Recupero dati soggetti da API...");
            try {
                const url = window.BaseUrlWebApi + `SoggettoVenditaAcquisto/GetDataByOffertaId?offertaId=${this._offertaId}`;
                const response = await this.auth.fetchWithAuth("GET " + url, {
                    cache: "no-cache",
                    headers: { 'content-type': 'application/json' },
                });

                if (response && response.length > 0) {
                    return response.map((s: any) => ({
                        id: s.Id,
                        personaGiuridica: s.PersonaGiuridica,
                        quota: s.Quota,
                        nome: s.Nome,
                        cognome: s.Cognome,
                        denominazione: s.Denominazione,
                        codiceFiscale: s.CodiceFiscale,
                        partitaIva: s.PartitaIva,
                        codiceSDI: s.CodiceSdi,
                        dataNascita: s.DataNascita,
                        idStatoNascita: s.IdStatoNascita,
                        idComuneNascita: s.IdComuneNascita,
                        luogoNascitaEstero: s.LuogoNascitaEstero,
                        idStatoResidenza: s.IdStatoResidenza,
                        idComuneResidenza: s.IdComuneResidenza,
                        capResidenza: s.CapResidenza,
                        idProvinciaResidenza: s.IdProvinciaResidenza,
                        luogoResidenzaEstero: s.LuogoResidenzaEstero,
                    }));
                }
            } catch (error) {
                console.error("Errore recupero soggetti:", error);
            }
        }

        return soggetti;
    }

    /**
     * Controlla se ci sono state modifiche rispetto allo snapshot
     */
    private async verificaModifiche(): Promise<boolean> {
        if (!this._snapshotDatiOfferta) {
            console.log("🔴 verificaModifiche - Nessuno snapshot precedente");
            return false; // Nessuno snapshot precedente
        }

        const snapshotCorrente = await this.creaSnapshotDatiOfferta();
        const sonoUguali = this._snapshotDatiOfferta === snapshotCorrente;

        console.log("━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━");
        console.log("🔍 CONFRONTO SNAPSHOT:");
        console.log("📌 Snapshot SALVATO:", this._snapshotDatiOfferta);
        console.log("📌 Snapshot CORRENTE:", snapshotCorrente);
        console.log("━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━");

        // Parsing per confronto dettagliato
        try {
            const salvato = JSON.parse(this._snapshotDatiOfferta);
            const corrente = JSON.parse(snapshotCorrente);

            console.log("🔎 Dettaglio confronto:");
            console.log("  • ProfiloId:", salvato.profiloId, "vs", corrente.profiloId, salvato.profiloId === corrente.profiloId ? "✅" : "❌");
            console.log("  • Nome offerente:", salvato.nomeOfferente, "vs", corrente.nomeOfferente, salvato.nomeOfferente === corrente.nomeOfferente ? "✅" : "❌");
            console.log("  • Cognome offerente:", salvato.cognomeOfferente, "vs", corrente.cognomeOfferente, salvato.cognomeOfferente === corrente.cognomeOfferente ? "✅" : "❌");
            console.log("  • Modalità acquisto:", salvato.modalitaAcquisto, "vs", corrente.modalitaAcquisto, salvato.modalitaAcquisto === corrente.modalitaAcquisto ? "✅" : "❌");
            console.log("  • Importo cauzione:", salvato.importoCauzione, "vs", corrente.importoCauzione, salvato.importoCauzione === corrente.importoCauzione ? "✅" : "❌");
            console.log("  • Num. soggetti:", salvato.soggetti.length, "vs", corrente.soggetti.length, salvato.soggetti.length === corrente.soggetti.length ? "✅" : "❌");

            // ✅ Confronto dettagliato soggetti
            if (salvato.soggetti.length > 0 || corrente.soggetti.length > 0) {
                console.log("  📋 Dettaglio soggetti:");
                const maxLen = Math.max(salvato.soggetti.length, corrente.soggetti.length);
                for (let i = 0; i < maxLen; i++) {
                    const sSalv = salvato.soggetti[i];
                    const sCorr = corrente.soggetti[i];
                    if (sSalv && sCorr) {
                        const uguali = JSON.stringify(sSalv) === JSON.stringify(sCorr);
                        console.log(`    [${i}] ${sSalv.nominativo || sSalv.id} ${uguali ? "✅" : "❌"}`);
                        if (!uguali && sSalv.nominativo) {
                            console.log(`        • CF: ${sSalv.codiceFiscale} vs ${sCorr.codiceFiscale}`);
                            console.log(`        • Quota: ${sSalv.quota} vs ${sCorr.quota}`);
                        }
                    } else if (sSalv) {
                        console.log(`    [${i}] ${sSalv.nominativo || sSalv.id} ❌ (rimosso)`);
                    } else if (sCorr) {
                        console.log(`    [${i}] ${sCorr.nominativo || sCorr.id} ❌ (aggiunto)`);
                    }
                }
            }
        } catch (e) {
            console.error("Errore nel parsing degli snapshot:", e);
        }

        console.log(sonoUguali ? "✅ Nessuna modifica rilevata" : "⚠️ MODIFICHE RILEVATE!");
        console.log("━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━");

        return !sonoUguali;
    }

    /**
     * Controlla se esiste una PIA già caricata
     */
    private verificaEsistenzaPIA(): boolean {
        const numPIA = $(".allegatoPia-item").length;
        console.log("🔵 verificaEsistenzaPIA - Numero PIA trovate nel DOM:", numPIA, "| Flag _existePIA:", this._existePIA);
        return numPIA > 0 || this._existePIA;
    }

    /**
     * Cancella la PIA esistente e mostra il form di upload
     */
    private async rimuoviPIAEsistente(): Promise<void> {
        const piaCancellata = await DeleteDocumentoGaraByOffertaIdAndTipo(this._offertaId, "PIA");

        if (piaCancellata) {
            // Rimuovi dalla UI
            $(".allegatoPia-item").remove();

            // Mostra il form di upload
            $("#divUploadFilePia").removeClass("d-none");
            $("#OffertaFilePia").val("").attr("required", "required");
            $("#divFilePia").addClass("d-none");

            // Reset snapshot
            this._snapshotDatiOfferta = null;
            this._existePIA = false;

            console.log("🗑️ PIA cancellata a causa di modifiche nei dati");
        }
    }

    /**
     * Resetta completamente un input file e il suo display associato
     */
    private resetFileInput(fileInput: HTMLInputElement, displayId: string): void {
        $(fileInput).val("");
        clearCustomFileError(fileInput);
        $(`#${displayId}`).empty();
    }

}

export default AdPropostaAcquisto;